import $ from 'jquery';

export function scrollToAnchor() {
    const hashId = window.location.hash.replace('#', '');
    if (hashId) {
        const section = document.querySelector(`[data-anchor=${hashId}]`);
        scrollToEl(section);
    }
}

export function scrollToEl(el) {
    if (el) {
        const topPos = el.offsetTop;
        $('html, body').animate({
            scrollTop: topPos - 100
        }, 1000);
    }
}